// Widget ekleme kataloğu — Blazor WidgetCatalog.
import { Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Dialog } from '@/shared/ui/Dialog';
import { WIDGET_CATALOG, canAddWidget, type WidgetDefinition, type WidgetType } from '../model/widgetLayout';

export function WidgetPicker({ open, onOpenChange, widgets, onAdd }: { open: boolean; onOpenChange: (o: boolean) => void; widgets: WidgetDefinition[]; onAdd: (type: WidgetType) => void }) {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onOpenChange={onOpenChange} title={t('home.addWidget')} size="lg">
      <ul className="grid grid-cols-1 gap-2 sm:grid-cols-2">
        {WIDGET_CATALOG.map((item) => {
          const can = canAddWidget(widgets, item.type);
          return (
            <li key={item.type}>
              <button
                type="button"
                disabled={!can}
                onClick={() => {
                  onAdd(item.type);
                  onOpenChange(false);
                }}
                className="border-border hover:border-brand-500 hover:bg-bg-hover flex w-full items-start gap-2 rounded-lg border p-3 text-left disabled:opacity-40 disabled:hover:border-border disabled:hover:bg-transparent"
              >
                <Plus className="text-brand-600 mt-0.5 h-4 w-4 shrink-0" />
                <span className="min-w-0">
                  <span className="block truncate text-sm font-medium">{t(item.nameKey)}</span>
                  <span className="text-fg-muted block text-xs">{t(item.descriptionKey)}</span>
                </span>
              </button>
            </li>
          );
        })}
      </ul>
    </Dialog>
  );
}
